import { toDateTime } from "./date+helper";

export function getGameKey(date: any, venue: string, court: string) {
  return `${toDateTime(date).toUTC().toISO()}_${venue}_${court}`;
}
